var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Confirm Sun Close Invoice " + _vm.invoice.invoiceNumber,
        visible: _vm.isShow,
        width: "80%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.isShow = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "w-100 d-flex justify-content-end" },
        [
          _c(
            "el-button",
            {
              staticClass: "ml-1",
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.confirmSunCloseSubmit(_vm.invoice)
                },
              },
            },
            [_vm._v("Confirm")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }